import { type Components, type Theme } from "@mui/material";

export const buttonGroupTheme: Components<Theme>["MuiButtonGroup"] = {
  defaultProps: {
    disableElevation: true,
    color: "secondary",
    variant: "contained",
  },
  styleOverrides: {
    root: ({ theme }) => ({
      boxShadow: "none",
      borderRadius: theme.borderRadius.md,
      "& .MuiButtonGroup-firstButton.Mui-disabled, & .MuiButtonGroup-middleButton.Mui-disabled":
        {
          borderRightColor: theme.palette.secondary.dark,
          borderLeftColor: theme.palette.secondary.dark,
        },
      variants: [
        {
          props: { size: "small" },
          style: { borderRadius: theme.borderRadius.sm },
        },
        {
          props: { size: "large" },
          style: { borderRadius: theme.borderRadius.lg },
        },
        {
          props: { color: "secondary", variant: "text" },
          style: {
            "& .MuiButton-root": {
              color: theme.palette.text.secondary,
              "&:hover": {
                backgroundColor: theme.palette.custom.fillSecondaryHover,
              },
            },
          },
        },
        {
          props: { color: "errorSecondary", variant: "text" },
          style: {
            "& .MuiButton-root": {
              color: theme.palette.errorSecondary.contrastText,
              "&:hover": {
                backgroundColor: theme.palette.errorSecondary.dark,
              },
            },
          },
        },
      ],
    }),
  },
};
